<template>
    <datepicker
        data-ui-date-picker
        :id="id"
        ref="datepickerComponent"
        v-model="localValue"
        :input-class="inputClass"
        :popup-class="noPicker ? 'hidden' : ''"
        format="DD.MM.YYYY"
        valueType="DD.MM.YYYY"
        :placeholder="noPicker ? 'ДД:ММ:ГГГГ' : placeholder"
        v-mask="'##.##.####'"
        :name="name"
        :disabled-date="(...args) => onDisabledDate(...args) || disabledDate(...args)"
        :clearable="clearable"
        @focus="hasFocus = true"
        @blur="onBlur"
    >
        <template #icon-calendar>
            <div
                class="icon icon_fix icon_size-16"
                :class="{
                    ['icon-calendar']: !dark,
                    ['icon-calendar-white']: dark,
                }"
            />
        </template>
        <template #icon-clear>
            <div
                class="icon icon_fix icon_size-16"
                :class="{
                    ['icon-close']: !dark,
                    ['icon-close-white']: dark,
                }"
            />
        </template>
    </datepicker>
</template>
<script>
import datepicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/ru'
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export default {
    name: 'UiDatePicker',
    components: {
        datepicker,
    },
    props: {
        value: String, // 'DD.MM.YYYY'
        id: String,
        dark: Boolean,
        disabled: Boolean,
        name: String,
        error: Boolean,
        noPicker: Boolean,
        min: String, // 'DD.MM.YYYY'
        max: String, // 'DD.MM.YYYY'
        clearable: Boolean,
        disabledDate: {
            type: Function,
            default: () => false,
        },
        placeholder: String,
    },
    data() {
        return {
            localValue: '',
            hasFocus: false,
            inputEl: undefined,
        };
    },
    computed: {
        inputClass() {
            return [
                'ui-text-input',
                'd-input',
                `${this.dark ? 'ui-text-input_dark' : ''}`,
                `${this.hasFocus ? 'ui-text-input_focus' : ''}`,
                `${this.error ? 'ui-text-input_invalid' : ''}`,
                `${this.localValue?.length > 0 ? 'ui-text-input_has-value' : ''}`,
                `${this.placeholder ? '' : 'ui-text-input_transparent-placeholder'}`,
            ].join(' ');
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.localValue = val;
            },
        },
        localValue(val) {
            if (val !== this.value) this.$emit('input', val);
        },
    },
    methods: {
        onBlur() {
            this.hasFocus = false;
            this.$refs.datepickerComponent.handleInputChange();
        },
        onDisabledDate(dateVal) {
            const min = dayjs(this.min, 'DD.MM.YYYY');
            const max = dayjs(this.max, 'DD.MM.YYYY');
            const date = dayjs(dateVal);
            let result = false;

            if (min.isValid()) result || (result = date.isBefore(min, 'day'));
            if (max.isValid()) result || (result = date.isAfter(max, 'day'));

            return result;
        },
    },
    mounted() {
        this.$refs.datepickerComponent.$refs.input.setAttribute('inputmode', 'numeric');
    },
};
</script>
<style lang="scss">
// TODO убрать костыль, когда везде будет использоваться ui-date-picker
[data-ui-date-picker] {

    .mx-input-wrapper .mx-icon-clear {
        display: block!important;
    }
    .mx-input-wrapper:hover .mx-icon-clear {
        display: block!important;
    }
    .mx-icon-clear {
        display: block!important;
    }
}
</style>
